import axios, { type AxiosResponse } from 'axios';
import { getConfig } from '../config';

export interface RedirectRule {
  sourceUrl: string;
  targetUrl: string;
}

export interface RedirectMappingsResponse {
  mappings: Record<string, string>;
}

export interface AddRedirectRequest {
  sourceUrl: string;
  targetUrl: string;
}

export interface DeleteRedirectRequest {
  sourceUrl: string;
}

export class SiteConfigClient {
  private readonly headers: Record<string, string>;

  constructor(private readonly apiUrl: string) {
    this.headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Origin: window.location.origin,
      'x-api-key': getConfig().apiKey,
    };
  }

  async getRedirectMappings(): Promise<RedirectRule[]> {
    try {
      const response: AxiosResponse<RedirectMappingsResponse> = await axios.get(
        `${this.apiUrl}/siteconfig/redirectionsMappings`,
        {
          headers: this.headers,
        },
      );

      const mappings = response.data.mappings || {};
      return Object.entries(mappings).map(([sourceUrl, targetUrl]) => ({
        sourceUrl,
        targetUrl,
      }));
    } catch (error) {
      console.error('Error getting redirect mappings:', error);
      throw error;
    }
  }

  async addRedirect(request: AddRedirectRequest): Promise<void> {
    try {
      await axios.post(
        `${this.apiUrl}/siteconfig/redirections`,
        {
          sourceUrl: request.sourceUrl,
          targetUrl: request.targetUrl,
        },
        {
          headers: this.headers,
        },
      );
    } catch (error) {
      console.error('Error adding redirect:', error);
      throw error;
    }
  }

  async deleteRedirect(request: DeleteRedirectRequest): Promise<void> {
    try {
      await axios.delete(`${this.apiUrl}/siteconfig/redirections`, {
        headers: this.headers,
        data: {
          sourceUrl: request.sourceUrl,
        },
      });
    } catch (error) {
      console.error('Error deleting redirect:', error);
      throw error;
    }
  }

  async purgeCache(): Promise<void> {
    try {
      await axios.post(
        `${this.apiUrl}/siteConfig/invalidateCache/cloudFlare`,
        {},
        {
          headers: this.headers,
        },
      );
    } catch (error) {
      console.error('Error purging cache:', error);
      throw error;
    }
  }
}

